import { useNavigate } from 'react-router-dom';
import Input from '../components/Input';
import Label from '../components/Label';
import { useEffect } from 'react';
import { validateGuid } from '../services/apiService';
import axios from 'axios';
import { getHeadersAPI } from '../api/ServicesConfiguration';

function ContractSignedWaiver() {
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get('guid');

  if (!guid) {
    navigate('/ErrorPage');
  }

  // FetchData
  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      navigate('/ErrorPage');
    }

    const response: any = await axios.get(
      process.env.REACT_APP_BASE_API_URL +
        '/getContractsByApplicationIdViaGuid/' +
        guid,
      {
        headers: await getHeadersAPI()
      }
    );

    if (response.data) {
      const contracts = response.data.filter(
        (c: any) => c.DocumentModel != 'Waiver'
      );

      const waiverByGuid = response.data.filter(
        (c: any) => c.Guid == guid && c.DocumentModel == 'Waiver'
      );

      if (
        contracts.filter((c: any) => !(c.SignatureStatus == 'SIGNED')).length >
        0
      ) {
      } else {
        await axios
          .post(
            process.env.REACT_APP_BASE_API_URL + '/allContractsSigned',
            { guid: guid },
            {
              headers: await getHeadersAPI()
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.error('API Error:', error);
          });
      }

    } else {
      navigate('/ErrorPage');
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      navigate('/ErrorPage');
    } else {
      fetchData();
    }
  }, []);

  function nextOnClick() {
    navigate(`/WaiverPage?guid=${guid}`);
  }
  return (
    <div>
      <div className="content mt-5">
        <div className="container">
          <div className="card p-5">
            <div className="row">
              <div className="col-lg-12">
                <div className="">
                  <div className="">
                    <div className="row">
                      <div className="col-lg-7">
                        <div className="row mt-5">
                          <div className="col-sm-12 mb-2">
                            <h1 className="m-0 form-header">
                              Bedankt voor het ondertekenen van het contract!
                            </h1>
                          </div>
                          <div className="pr-5 mb-5">
                            <div className="col-sm-12 mb-2">
                              Het tekenen van het contract is gelukt en de
                              handtekening wordt gecontroleerd.
                            </div>
                            <div className="col-sm-12">
                              Wij houden u per e-mail op de hoogte over uw
                              aanvraag, dus houd uw mailbox in de gaten.
                            </div>
                          </div>
                          <div>
                            <a
                              style={{ cursor: 'pointer' }}
                              onClick={nextOnClick}
                            >
                              <h5
                                style={{ color: '#ec0000', fontWeight: 'bold' }}
                              >
                                Lees meer over de volgende stappen en het
                                bestelproces van de auto{' '}
                                <i className="fas fa-chevron-right"></i>
                              </h5>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5">
                        <img
                          src="../../dist/img/DoingBusiness 1.png"
                          alt="AdminLTE Logo"
                          className="brand-image"
                          style={{ opacity: '.8', width: 400 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContractSignedWaiver;
